import { render, staticRenderFns } from "./ResourceForms.vue?vue&type=template&id=8ca9b2fe&scoped=true"
import script from "./ResourceForms.vue?vue&type=script&lang=ts"
export * from "./ResourceForms.vue?vue&type=script&lang=ts"
import style0 from "./ResourceForms.vue?vue&type=style&index=0&id=8ca9b2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9b2fe",
  null
  
)

export default component.exports